<template>
  <div class="date-and-time">
    <div class="date-wrapper">
      <h1 class="date">{{content.date}}</h1>
      <h1 class="date divider"> | </h1>
      <h1 class="date">{{content.start_time}} - {{content.end_time}} UTC</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "date_and_time",
  props: {
    content: Object
  },
  data: () => ({
    date: "",
  }),
  // created() {
  //   var parts = this.content.date.split("/");
  //   var date = new Date(parseInt(parts[2], 10),
  //                     parseInt(parts[1], 10) - 1,
  //                     parseInt(parts[0], 10));
  //   var options = [{day: 'numeric'}, {month: 'long'}, {year: 'numeric'}];
  //   this.date= date.toLocaleDateString("en-GB", options);
  // }
};
</script>

<style lang="scss">
.date-and-time{
  position: relative;
  text-align: right;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 10%;
    height: 100%;
    // background: rgba(184, 184, 184, 0.2);
  }
  .date-wrapper {
    display: inline-block;
    padding: 50px 100px 0px 100px;
    width: calc(65% + 100px);
    text-align: left;
    position: relative;
    z-index: 1;
    // position: relative;
    // background: $white;
    // margin-bottom: 20px;
    // margin-top: 20px;
    // height: 42px;
    // text-align: center;
    .date {
      @include oswald;
      text-transform: uppercase;
      letter-spacing: 0.2em;
      text-align: center;
      // vertical-align: middle;
      position: relative;
      // background-color: red;
      float: center; 
      display:block!important;
      width: 100%!important;
      margin-bottom: 0px!important;
      
      &.divider{
        width: 80px;
        display: none!important;
      }
      // margin-top: 50%;
      // -ms-transform: translateY(-50%);
      //  transform: translateY(-50%);
      // top: 50%;
      // margin-bottom: 85px;
      // transition: all 1s;
      // transition-delay: 0.2s;
    } 
  }
}
@media (max-width: $tablet) {
  .date-and-time {
    text-align: center;
    .date-wrapper{
      padding: 50px 50px 0px 50px;
      max-width: calc(65% + 50px);
    }
    &:before {
      display: none;
    }
  }
}

@media (max-width: $mobile) {
  .date-and-time{
    .date-wrapper {
      max-width: 90%;
      padding: 50px 50px 0px 50px;
      height: 72px!important;
    }
  }
  .date{
    display:block!important;
    width: 100%!important;
    margin-bottom: 0px!important;
  }
  .divider{
      display: none!important;
  }

}
</style>